var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCompanyQueries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.935,
    height: 22.317,
    viewBox: "0 0 21.935 22.317",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d",
    "data-name": "tspBW3.tif"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.301.051c1.96.064,4.028-.128,5.977-.015,2.394.14,4.267,1.966,4.416,4.372.136,2.204-.106,4.546-.002,6.764-.178,1.02-1.535,1.084-1.799.076l-.016-6.79c-.077-1.264-1.155-2.45-2.429-2.568-1.988-.183-4.26.126-6.277.011-1.526.31-2.286,1.378-2.362,2.893-.208,4.13.162,8.433,0,12.581-.009,1.425,1.063,2.762,2.52,2.865,1.847.13,3.903-.161,5.733-.004,1.164.1,1.315,1.501.238,1.835-1.916-.047-3.936.128-5.842.021C2.005,21.956.152,20.134,0,17.679V4.365C.143,2.061,2,.201,4.301.051Z",
    fill: "#bababa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.325,17.724c1.929-.016,4.304,1.512,4.6,3.518.113.763-.697,1.345-1.374.944-.406-.241-.498-.936-.768-1.342-1.177-1.772-3.987-1.676-4.996.2-.212.394-.204.859-.609,1.114-.567.357-1.339.047-1.408-.633-.062-.607.49-1.553.863-2.024.865-1.093,2.296-1.766,3.694-1.777Z",
    fill: "#bababa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.325,12.211c2.951-.024,3.09,4.47.119,4.599-3.056.132-3.184-4.574-.119-4.599Z",
    fill: "#bababa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.599,12.43c.495.435.378,1.268-.228,1.529-.293.126-1.121.134-1.448.082-.874-.138-1.039-1.385-.247-1.734.41-.181,1.573-.186,1.924.123Z",
    fill: "#bababa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4,12.211c.249-.034.815-.04,1.062-.007,1.12.146,1.128,1.735.003,1.848-.331.033-1.086.038-1.373-.091-.821-.369-.631-1.621.307-1.749Z",
    fill: "#bababa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.357,8.549c.329-.047,1.154-.049,1.442.087.69.323.671,1.384-.04,1.659-.34.131-1.141.136-1.494.047-.96-.242-.898-1.65.092-1.793Z",
    fill: "#bababa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.967,8.549c.311-.045,1.094-.044,1.376.066.656.257.764,1.174.183,1.578-.4.279-1.582.285-1.975,0-.686-.498-.413-1.523.417-1.643Z",
    fill: "#bababa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.924,4.888c.329-.048,1.197-.049,1.485.086.786.369.589,1.613-.29,1.711-.388.044-1.284.054-1.594-.173-.642-.469-.384-1.51.399-1.625Z",
    fill: "#bababa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.924,15.915c.329-.048,1.197-.049,1.485.086.786.369.589,1.613-.29,1.711-.388.044-1.284.054-1.594-.173-.642-.469-.384-1.51.399-1.625Z",
    fill: "#bababa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.313,4.887c.359-.057,1.307-.059,1.602.143.692.473.413,1.563-.406,1.656-.284.032-1.16.031-1.4-.065-.788-.316-.678-1.595.204-1.734Z",
    fill: "#bababa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.313,15.914c.359-.057,1.307-.059,1.602.143.692.473.413,1.563-.406,1.656-.284.032-1.16.031-1.4-.065-.788-.316-.678-1.595.204-1.734Z",
    fill: "#bababa"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyQueries);
export default __webpack_public_path__ + "static/media/CompanyQueries.7f7e8cbf.svg";
export { ForwardRef as ReactComponent };